/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailslegalnamerequired4Inputs */

const en_companydetailslegalnamerequired4 = /** @type {(inputs: Companydetailslegalnamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter the official name.`)
};

const de_companydetailslegalnamerequired4 = /** @type {(inputs: Companydetailslegalnamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib den offiziellen Namen ein.`)
};

/**
* | output |
* | --- |
* | "Please enter the official name." |
*
* @param {Companydetailslegalnamerequired4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailslegalnamerequired4 = /** @type {((inputs?: Companydetailslegalnamerequired4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailslegalnamerequired4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailslegalnamerequired4(inputs)
	return de_companydetailslegalnamerequired4(inputs)
});
export { companydetailslegalnamerequired4 as "companyDetailsLegalNameRequired" }